// @flow
import * as React from 'react';
import {useParams} from "react-router-dom";
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";
import {GiTwoCoins} from "react-icons/gi";
import {
    TbArrowBadgeLeft, TbDiscount2,

    TbSquareRoundedMinus,
    TbSquareRoundedPlusFilled
} from "react-icons/tb";

import {useNavigate} from "react-router-dom";
import {RiHeart3Fill, RiHeart3Line, RiPercentFill} from "react-icons/ri";

import {FaCircleInfo} from "react-icons/fa6";
import FestivalBadge from "../../Assets/Images/festival.png";
import {SlBadge} from "react-icons/sl";


const currencyFormat = Intl.NumberFormat('en-US');
export default function VendorProducts() {
    const navigate = useNavigate();
    const {id} = useParams();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [showCountBox, setShowCountBox] = React.useState(false);
    const [countIndex, setCountIndex] = React.useState(0);
    const [countId, setCountId] = React.useState(0);
    const [theCount, setTheCount] = React.useState(0);
    const [countPrice, setCountPrice] = React.useState(0);
    const [vendor, setVendor] = React.useState([]);
    const [products, setProducts] = React.useState([]);
    const [search, setSearch] = React.useState('');
    const [totalPrice, setTotalPrice] = React.useState(parseInt(window.localStorage.getItem("totalPrice")));
    const [cart, setCart] = React.useState([]);

    React.useEffect(() => {
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));
        let vendorID = window.localStorage.getItem("vendorID");
        if (vendorID !== id) {
            cartItems = null;
        }
        if (cartItems) {
            setCart(cartItems)
        }
        let params = { };
        if(window.localStorage.getItem("fromSearch")) {
             params = {
                search: window.localStorage.getItem("searchTerm")
            }
            setSearch(window.localStorage.getItem("searchTerm"))
        }
        else {

        }

        API.getVendor(id, params)
            .then((response) => {
                setVendor(response.data);
                setProducts(response.data.products)
                setIsLoaded(true);
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
        setTimeout (() => {
            let scrollPosition = localStorage.getItem('scrollPosition');
            if (!scrollPosition) scrollPosition = 0;
            window.scrollTo({top: scrollPosition, behavior: 'smooth'});
            localStorage.removeItem('scrollPosition');
        },1000)
    }, [id]);

    const onPlusClick = (productID, price) => {
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));
        let vendorID = window.localStorage.getItem("vendorID");
        setTotalPrice(totalPrice + price)
        window.localStorage.setItem("totalPrice", totalPrice + price);

        if (vendorID !== id) {
            cartItems = null;
            setTotalPrice(price)
            window.localStorage.setItem("totalPrice", price);
        }
        let count = 1;
        if (cartItems) {
            const find_item = cartItems.find(x => x.item === productID);
            if (find_item) {
                count = find_item.count + 1;
                const objIndex = cartItems.findIndex((obj => obj.item === productID));
                cartItems[objIndex].count = count;
            } else {
                cartItems.push({'item': productID, 'count': count})
            }
        }
        if (!cartItems) { //Object.keys(this.state.markets).length < 1
            cartItems = [];
            cartItems.push({'item': productID, 'count': count})
        }
        setCart(cartItems);
        window.localStorage.setItem("cart", JSON.stringify(cartItems));
        window.localStorage.setItem("vendorID", id);
        window.localStorage.setItem("companyName", vendor.title);

        /*      setProducts(products.map((product) => {
                  if (product.id === productID) {
                      if(product.count > 0) {
                          product.count += 1;
                      }
                      else {
                          product.count = 1;
                      }

                   /!*   this.setState({sum_product_selected: this.state.sum_product_selected + 1 ,sum_price: this.state.sum_price + +product.discounted_price })*!/
                  }
                  return product;
              }));*/

    }
    const massProductIncrease = (productID, price) => {
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));
        setTotalPrice(totalPrice + price)
        window.localStorage.setItem("totalPrice", totalPrice + price);


        let count = parseInt(theCount);
        if (cartItems) {
            const find_item = cartItems.find(x => x.item === productID);
            if (find_item) {
                const objIndex = cartItems.findIndex((obj => obj.item === productID));
                cartItems[objIndex].count = count;
            } else {
                cartItems.push({'item': productID, 'count': count})
            }
        }
        if (!cartItems) { //Object.keys(this.state.markets).length < 1
            cartItems = [];
            cartItems.push({'item': productID, 'count': count})
        }
        setCart(cartItems);
        window.localStorage.setItem("cart", JSON.stringify(cartItems));
        window.localStorage.setItem("vendorID", id);
        window.localStorage.setItem("companyName", vendor.title);

        setShowCountBox(false);
        setTheCount(0)
        setCountPrice(0)
        setCountId(0)
    }

    const onMinusClick = (productID, price) => {
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));
        setTotalPrice(totalPrice - price)
        window.localStorage.setItem("totalPrice", totalPrice - price);

        if (cartItems) {
            const find_item = cartItems.find(x => x.item === productID);
            if (find_item) {
                const count = find_item.count;
                const objIndex = cartItems.findIndex((obj => obj.item === productID));
                if (count > 1) {
                    cartItems[objIndex].count = count - 1;
                } else {
                    cartItems.splice(objIndex, 1)
                }
                setCart(cartItems)
                window.localStorage.setItem("cart", JSON.stringify(cartItems));
            }
        }

    }

    const getItemCartCount = (productID) => {
        const find_item = cart.find(x => x.item === productID);
        if (find_item) {
            return (find_item.count)
        } else {
            return 0
        }
    }

    const onSearchProducts = (event) => {

        setSearch(event.target.value);
        window.localStorage.removeItem("fromSearch");
        if (event.target.value.length > 3) {
            setIsLoaded(false);
            const params = {
                search: event.target.value
            }
            API.getVendor(id, params)
                .then((response) => {
                    setVendor(response.data);
                    setProducts(response.data.products)
                    setIsLoaded(true);
                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        } else if (event.target.value.length < 1) {
            setIsLoaded(false);
            const params = {}
            API.getVendor(id, params)
                .then((response) => {
                    setVendor(response.data);
                    setProducts(response.data.products)
                    setIsLoaded(true);
                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }

    }

    const onSelectGroup = (event, gid,) => {
        if(gid > 0) {
            const el = document.getElementById('groups-container');
            // el.scrollLeft -= 100;
            el.scrollTo({top: 0, left: el.scrollLeft - 120, behavior: 'smooth'});
        }


        window.localStorage.removeItem("fromSearch");
        var items = document.getElementsByClassName('product-group-badge');

        for (var i = 0; i < items.length; i++) {
            items[i].style.backgroundColor = '#FFF';
        }
        event.target.style.backgroundColor = 'rgba(255, 152, 0, 0.6)'


        //setIsLoaded(false);
        const params = {
            search: search,
            group_id: gid
        }
        API.getVendor(id, params)
            .then((response) => {

                setVendor(response.data);
                setProducts(response.data.products)
                setIsLoaded(true);


            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }

    const onContinueClick = () => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (token) {
            if (window.localStorage.getItem("needRegistration")) {
                navigate('/register');
                return true;
            }
            navigate('/cart');
            return true;
        }
        navigate('/login')
    }
    const favorite = () => {
        const params = {}
        API.favoriteVendor(id, params)
            .then((response) => {
                toast.success(response.message);
                API.getVendor(id, params)
                    .then((response) => {
                        setVendor(response.data);
                        setProducts(response.data.products)
                    })
                    .catch((error) => {
                        if (error.response) {
                            toast.error(error.response.data.message);
                        } else {
                            toast.error(error.message);
                        }
                    });
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }

    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header hasBack={true} transparent={true}/>

            {
                showCountBox ?
                    <section className="container-fluid rtl select-product-count fixed-bottom  max-w-lg mt-5 pt-5">
                        <div className="row mx-2 pt-4 mt-5">
                            <div className="col-12 text-center m-3">
                                <img src={products[countIndex]?.cover_image} alt={products[countIndex]?.name} className='w-25 rounded border p-1 bg-white' />
                            </div>
                            <div className="col-12 mt-3 text-center">
                                تعداد مورد نظر برای خرید
                                &nbsp;
                                <strong>
                                    {products[countIndex]?.name}
                                </strong>
                                &nbsp;
                                را وارد کنید
                            </div>
                            <div className="col-12 mt-3">
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-big-2 "
                                           id="floatingInput"
                                           placeholder="تعداد"
                                           value={theCount}
                                           onChange={
                                               (event) => {
                                                   setTheCount(event.target.value)
                                               }
                                           }

                                    />
                                    <label htmlFor="floatingInput" className="right-0 text-secondary text-small-1">تعداد شل</label>
                                </div>
                            </div>

                            <div className="col-8 mt-5">
                                <button className='btn btn-success w-100'
                                        onClick={ () => {
                                            massProductIncrease(countId,countPrice)
                                        }  }
                                >
                                    تایید
                                </button>
                            </div>
                            <div className="col-4 mt-5">
                                <button className='btn btn-secondary w-100'
                                onClick={
                                    () => {
                                        setShowCountBox(false)
                                    }
                                }
                                >
                                    انصراف
                                </button>
                            </div>
                        </div>
                    </section>
                    : ''
            }


            <section className="container-fluid   rtl px-0 mx-0 products-list ">
                <div className="row mx-0 px-0">
                    <div className="col-12 px-0 bg-white">
                        {
                            vendor.is_selected > 0 &&
                            <img alt='festival' src={FestivalBadge}
                                className='festivalPic'
                            />


                        }
                        <img src={vendor.cover_photo} alt={vendor.title}
                             className='w-100 company-cover-photo'/>

                    </div>
                </div>
                <div className="row mx-1 mt-2 mx-2">
                    <div className="col-6 text-end mt-2 fw-bold"
                         onClick={() =>
                             navigate(`/vendor/info/${id}/`)
                         }
                    >
                        {vendor.title}

                    </div>
                    <div className="col-6 text-start text-big-2 mt-1 text-dark">
                        <span onClick={favorite}>
                                {
                                    vendor.is_favorite ?
                                        <RiHeart3Fill className='ms-3 text-danger'/> :
                                        <RiHeart3Line className='ms-3'/>
                                }
                        </span>

                        <span onClick={() =>
                            navigate(`/vendor/info/${id}/`)
                        }>
                            <FaCircleInfo className='text-dark'/>
                        </span>
                    </div>
                    {
                        vendor.cash_discount_percent > 0 &&

                    <div className="col-12 mt-4 text-small-3">

                        <div className="alert alert-success py-1">
                            <TbDiscount2 className='ms-1 text-big-5 text-success '/>
                            با تسویه نقدی از این تامین کننده
                            {" "}
                            {vendor.cash_discount_percent}
                            % تخفیف نقدی بگیرید
                        </div>

                    </div>
                    }

                    {vendor.discount_percent > 0 &&
                    <div className="col-12 my-0  text-small-3">
                        <div className="alert alert-info py-1">
                           <TbDiscount2 className='ms-1 text-big-5 text-info' />

                        با سفارش بیشتر از
                        {currencyFormat.format(vendor.threshold_discount)}
                        {" "}
                        ریال
                        {" "}
                        {vendor.discount_percent}

                        %

                تخفیف حجمی بگیرید.

                        </div>
                    </div>
                    }

                    {vendor.is_selected > 0 &&
                    <div className="col-12 mt-0 text-small-3">
                        <div className="alert alert-warning py-2 text-justify">
                           <SlBadge className='ms-1 text-big-5 text-warning ' />
                            این شرکت پخش منتخب جشنواره است و سفارشات شما شامل هدیه نقدی می شود .

                            <a href="https://pakhshman.ir/festival" target="_blank" className='float-start'>
                                بیشتر بدانید
                            </a>
                        </div>
                    </div>
                    }


                    <div className="col-12 mt-0">
                    <div className='bg-custom py-3 mb-2 rounded'>
                                <input type="text" className="w-100 rounded border-0 bg-white text-small-3 p-2"
                                       placeholder="جستجوی کالا بر اساس عنوان"
                                       value={search}
                                       onChange={onSearchProducts}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row   flex-nowrap mx-2 product-group-row border-bottom pb-4"
                         id='groups-container'
                    >
                        <div className="col-3 badge badge-pill mx-2 product-group-badge "
                             style={{backgroundColor: 'rgba(255, 152, 0, 0.6)'}}
                             onClick={
                                 (e) => {
                                     onSelectGroup(e, 0);
                                 }
                             }
                        >
                            همه
                        </div>
                        {
                            isLoaded && vendor.groups.map(group => {
                                    return (
                                        <div className="col-3 badge badge-pill mx-2 product-group-badge " key={group.id}

                                             onClick={
                                                 (e) => {
                                                     onSelectGroup(e, group.id);

                                                 }
                                             }
                                        >
                                            {group.name}
                                        </div>
                                    );
                                }
                            )
                        }
                    </div>
            </section>

            <section className="container-fluid  rtl pb-5 ">

                {
                    isLoaded && products.map((product , index) => {
                        const price = product.vendor_price.discounted_price
                        let finalPrice = product.vendor_price.discounted_price;
                        if(product.vendor_price.wholesale_amount > 0 && getItemCartCount(product.id) >= product.vendor_price.wholesale_amount) {
                            finalPrice = product.vendor_price.wholesale_discounted_price
                        }

                    return (
                        <div className="row vendor-product mx-2 py-2"

                             key={product.id}
                        >
                            <div className="col-3 p-1">
                                <img src={product.cover_image} alt={product.name}
                                     onClick={() => {
                                         localStorage.setItem('scrollPosition', window.scrollY);
                                         window.localStorage.setItem("companyName", vendor.title);
                                         navigate(`/vendor/${id}/${product.id}`)

                                     }


                                }

                                />
                                {
                                    product.in_box_count > 1  ?
                                <div className='badge badge-info badge-pill bg-primary-color text-center w-100 text-small-3'>
                                    <span className='text-small-2'>
                                        {
                                            product.counting_unit?.title
                                        }
                                    </span>
                                    &nbsp;
                                        {
                                            product.in_box_count
                                        }
                                    &nbsp;
                                    {
                                        product.unit
                                    }

                                    </div>
                                        : '' }
                            </div>
                            <div className="col-9 p-1">
                                <div className="fw-bold">
                                    {product.name}

                                </div>

                                {product.vendor_price.consumer_price ?
                                    <div className="text-small-4 pe-3 mt-3 text-dark">
                                        <GiTwoCoins className='ms-2 '/>
                                        قیمت مصرف کننده:
                                        &nbsp;
                                        &nbsp;
                                        {currencyFormat.format(product.vendor_price.consumer_price)}
                                        <span className='text-small-3'>
                                                    &nbsp;
                                            ریال
                                            &nbsp;
                                                    </span>
                                    </div>
                                    : ''
                                }


                                {product.vendor_price.each_price ?
                                    <div className="text-small-3 pe-3 mt-2 text-dark ">
                                        <GiTwoCoins className='ms-2 '/>
                                        قیمت هر عدد:
                                        &nbsp;
                                        &nbsp;

                                        {currencyFormat.format(product.vendor_price?.each_price)}
                                        <span className='text-small-3'>
                                                    &nbsp;
                                            ریال
                                            &nbsp;
                                                    </span>


                                    </div>
                                    : ''
                                }

                                {product.vendor_price.price ?
                                    <div className="text-small-3 pe-3 mt-2 text-muted fw-bold">
                                        <GiTwoCoins className='ms-2 '/>
                                        قیمت پایه:
                                        &nbsp;
                                        &nbsp;
                                        {
                                            product.vendor_price.discount_percent > 0 &&
                                            <span
                                                className='text-decoration-line-through fw-normal text-small-3 px-2 '>
                                                       {currencyFormat.format(product.vendor_price.price)}

                                            </span>
                                        }
                                        {currencyFormat.format(price)}
                                        &nbsp;
                                        <span className='text-small-3 text-muted'>ریال</span>
                                        {product.vendor_price.consumer_price > 1 && product.in_box_count > 0 &&
                                        <span className='badge rounded-pill bg-success-subtle text-dark text-big-1'>
                                            {Math.round(((product.vendor_price.consumer_price - (price / product.in_box_count)) / product.vendor_price.consumer_price) * 100)} %
                                        </span>
                                        }
                                        &nbsp;
                                    </div>
                                    : ''
                                }

                                {product.vendor_price.wholesale_discounted_price ?
                                    <div className="text-small-3 pe-3 mt-2 text-dark fw-bold">
                                        <GiTwoCoins className='ms-2 '/>
                                        قیمت عمده:

                                        <span className='text-small-2'>
                                                                                                                        (
                                        بالای

                                        <strong>{
                                            product.vendor_price.wholesale_amount
                                        }</strong>
                                            &nbsp;
                                            {
                                                product.counting_unit?.title
                                            }
                                            )
                                            </span>
                                        :
                                        &nbsp;
                                        {currencyFormat.format(product.vendor_price.wholesale_discounted_price)}
                                        <span className='text-small-3'>
                                                    &nbsp;
                                            ریال
                                            &nbsp;
                                                    </span>
                                        {product.vendor_price.consumer_price > 1 && product.in_box_count > 0 &&
                                        <span className='badge rounded-pill bg-success-subtle text-dark text-big-1'>
                                            {Math.round(((product.vendor_price.consumer_price - (product.vendor_price?.wholesale_discounted_price / product.in_box_count)) / product.vendor_price.consumer_price) * 100)} %
                                        </span>
                                        }
                                    </div>
                                    : ''
                                }

                            </div>
                            <div className="col-12 px-2 mx-0 mt-0 ">
                                {
                                    getItemCartCount(product.id) > 0 ?

                                        <div className='float-end mt-3 text-dark fw-bold me-1 '>
                                            {
                                                currencyFormat.format(getItemCartCount(product.id)  *  finalPrice )
                                            }
                                            &nbsp;
                                            <span className='text-small-3 text-secondary opacity-50'>ریال</span>
                                        </div> : ''
                                }

                                <div className="add-minus-products text-start">

                                    {
                                        getItemCartCount(product.id) > 0 ?
                                            <span className="add-product-icon text-secondary "
                                                  onClick={() => {
                                                      onMinusClick(product.id, price);

                                                  }}>
                                         <TbSquareRoundedMinus/>

                                     </span> : <span>&nbsp;</span>
                                    }

                                    {
                                        getItemCartCount(product.id) > 0 ?
                                            <span className="px-2" onClick={
                                                () => {
                                                    setShowCountBox(true)
                                                    setCountIndex(index)
                                                    setCountId(product.id)
                                                    setCountPrice(price)
                                                    setTheCount(getItemCartCount(product.id))
                                                }
                                            }>
                                    <input type="tel" className="bg-white" value={getItemCartCount(product.id)}
                                           readOnly/>
                                </span> : <span>&nbsp;</span>
                                    }

                                    <span className="add-product-icon   "
                                          onClick={() => {
                                              onPlusClick(product.id, price);

                                          }}>
                                         <TbSquareRoundedPlusFilled className='text-secondary-color'/>
                                    </span>
                                </div>
                            </div>
                        </div>
                    );

                    }
                )
                }
                {
                    cart.length > 0 ?
                        <div className="row">
                            <div className="col-12 p-2 fixed-bottom max-w-lg">
                                <button
                                    className="btn btn-warning text-end text-small-1 text-semi-big  w-100 p-2  pe-4 border-0"
                                    onClick={onContinueClick}
                                >
                                    مشاهده سبد خرید
                                    <span className="badge  p-2 float-start">
                                       {/*    <span className='text-white-50 px-2 text-big-2'>
                                                {currencyFormat.format(totalPrice)}

                                               &nbsp;
                                               ریال
                                           </span>*/}
<TbArrowBadgeLeft className='text-big-3'/>
                    </span>
                                </button>
                            </div>
                        </div>
                        : ''
                }

            </section>
            <div className='py-5'>
                &nbsp;
            </div>
        </React.Fragment>
    );
}